// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"c8033f65","410":"bf69d886","657":"066ba9d9","982":"6465aa0f"}[chunkId] + ".chunk.css";
};